import MotifHistoire from '@/views/consultations/en-cours/motif-histoire';
import kineConsultationMode from './kine-consultation-mode'
import KineReeducation from '@/components/kine-reeducation.vue'
import { BModal } from 'bootstrap-vue'
import sageFemmeApi from '@/modules/sage-femme/api'

import ExamenClinique from '@/views/consultations/en-cours/examen-clinique';
import Constantes from '@/views/consultations/en-cours/constantes'
import ConstantesInfirmier from '@/views/tableau-de-bord/dashboard-infirmier/constantes-infirmier'
import PlanAdministrationInfirmier from '@/views/patientInfo/plan-administration-infirmier.vue'
import infirmier_api from '@/api/_infirmier'

import HypotheseDiagnostic from '@/views/consultations/en-cours/hypothese-diagnostic';
import Diagnostic from '@/views/consultations/en-cours/diagnostics';

import ExamenBio from '@/views/consultations/en-cours/examen-bio';
import ExamenPara from '@/views/consultations/en-cours/examen-para';
import ProtocoleSoins from '@/views/consultations/en-cours/protocole-soins';
import OrdonnanceMedicale from '@/views/consultations/en-cours/ordonnance-medicale';

import CertifMedical from '@/views/consultations/en-cours/certif-medical';
import RendezVous from '@/views/consultations/en-cours/rendez-vous';
import FacteurPonderation from '@/views/consultations/en-cours/cpn/facteur-ponderation'
import ScorePonderation from '@/views/consultations/en-cours/cpn/score-ponderation'
import ConfirmFinConsultation from '@/views/consultations/en-cours/confirm-fin-consultation'
import AvisMedical from '@/views/consultations/en-cours/avis-medical'
import Plaintes from '@/views/consultations/en-cours/plaintes'

// ATCD ENF
import ATCDENFPersonnel from '@/views/consultations/en-cours/antecedent-enf-personnel'
import ATCDENFFamiliaux from '@/views/consultations/en-cours/antecedent-enf-familiaux'

// ATCD Allergologie
import ATCDAllergoPersonnel from '@/views/consultations/en-cours/antecedent-allergologie-personnel'
import ATCDAllergoFamiliaux from '@/views/consultations/en-cours/antecedent-allergologie-familiaux'
import ATCDAllergoEnvironnement from '@/views/consultations/en-cours/antecedent-allergologie-environnement'

// ATCD Neonatologie
import ATCDNeonatologieGeniteur from '@/views/consultations/en-cours/antecedent-neonatologie-geniteur'

// ATCD Adulte
import ATCDAdultePersonnel from '@/views/consultations/en-cours/antecedent-adulte-personnel'
import ATCDAdulteFamiliaux from '@/views/consultations/en-cours/antecedent-adulte-familiaux'

// Histoire de la maladie
import HistoireDelaMaladie from '@/views/consultations/en-cours/histoire-de-la-maladie'

import ManageEvolution from '@/views/consultations/en-cours/manage-evolution'
import ComplementBandeau from './complement-bandeau.vue'
import EvolutionsComplement from './evolutions-complement.vue'
import VoirResultat from '@/views/analyse/visualiser-resultat';
import ExamenPreviewResult from '@/views/consultations/en-cours/examen-para/examen-preview-result'

// FEMME ENCEINTE
import Grossesse from '@/views/consultations/en-cours/grossesse'
import ExamenFemmeEnceinte from '@/views/consultations/en-cours/grossesse/examen-physique-fe'

import AcuiteVisuelle from '@/views/consultations/en-cours/ophtalmologie/acuite-visuelle'
import OrdonnaceDeLunettes from '@/views/consultations/en-cours/ophtalmologie/ordonnance-lunettes'

import ConsultationSections from '@/views/consultations/en-cours/consultation-sections'

import ChoixFicheConsultation from '@/views/consultations/en-cours/choix-fiche-consultation'
import CertificatsMedicaux from '@/views/consultations/en-cours/certificats-medicaux'

import DHIS2Diagnostics from '@/views/consultations/en-cours/dhis2-diagnostics'
import { sectionDisponibleDansDossier } from '@/utils/consultation-section-availability'

import $ from 'jquery'
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import store_fiche from "@/store/mods/consultations/fiche-consultations"
import store_patient from '@/store/mods/patients/patient'

// Les données historiques restent en base, mais ces anciens points d'entrée ne
// doivent plus recréer un second parcours de soins dans le dossier courant.
const sectionsLegacyMasquees = new Set(['protocole_soins', 'carnet_sante', 'commentaire'])

export default {
    name: 'en-cours',
    mixins: [kineConsultationMode],
    components: {
        KineReeducation, BModal,
        MotifHistoire, ExamenClinique, HypotheseDiagnostic,
        ExamenBio, ExamenPara,
        OrdonnanceMedicale, CertifMedical, ProtocoleSoins,
        RendezVous, FacteurPonderation,
        ScorePonderation, ConfirmFinConsultation, AvisMedical, Plaintes,
        Diagnostic, ATCDENFPersonnel, ATCDENFFamiliaux,
        ATCDAllergoPersonnel, ATCDAllergoFamiliaux, ATCDAllergoEnvironnement,
        ATCDNeonatologieGeniteur, ATCDAdultePersonnel,
        ATCDAdulteFamiliaux, HistoireDelaMaladie, Constantes,
        ManageEvolution, ComplementBandeau, EvolutionsComplement, VoirResultat, ExamenPreviewResult, ChoixFicheConsultation,
        Grossesse, ExamenFemmeEnceinte, AcuiteVisuelle, OrdonnaceDeLunettes,
        ConsultationSections, CertificatsMedicaux, DHIS2Diagnostics, ConstantesInfirmier, PlanAdministrationInfirmier
    },
    directives: {
        observeSection: {
            inserted(element, binding, vnode) {
                if (binding.value.immediate) return
                const vm = vnode.context
                const cle = binding.value.cle
                if (!window.IntersectionObserver) {
                    vm.$set(vm.sections_chargees, cle, true)
                    return
                }
                const observer = new IntersectionObserver(entries => {
                    if (!entries.some(entry => entry.isIntersecting)) return
                    vm.$set(vm.sections_chargees, cle, true)
                    observer.disconnect()
                    delete element._dossierSectionObserver
                }, { rootMargin: '450px 0px' })
                element._dossierSectionObserver = observer
                observer.observe(element)
            },
            unbind(element) {
                if (element._dossierSectionObserver) element._dossierSectionObserver.disconnect()
                delete element._dossierSectionObserver
            }
        }
    },

    props: {
        activeRole: String,
        user_id: Number,
        user_info: {
            type: Object,
            default: () => ({})
        },
        patient: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            constantes_infirmier_ouvertes: false,
            initiale_id: null,
            vm_state: open_menu_state,
            analyse: true,
            examen: false,
            conduite: true,
            ordonnance: true,
            certificat: false,

            prescription_loading: true,
            examenbio_loading: true,
            consultation_id: null,
            exam_physique: [],

            end_loading: false,
            actions_options_ouvertes: false,
            avis_en_attente: 0,

            group_section_loading: true,
            group_section_error: false,
            groupe_actif_id: null,
            groupes_ouverts: {},
            groupes_charges: {},
            sections_repliees: {},
            sections_chargees: {},
            groupe_togglers: {},
            initiale_ouverte_consultation_id: null,
            section_is_loading: true,
            section_is_empty: false,
            selected_evolution: {},

            evolution_toggler: 0,
            toggler: 0,
            result_toggler: 0,
            info_resultat: {},
            demande_analyse: {},
            demande_examen: {},
            evolution_id: 0,

            // ==================================
            searchTerm: '',
            curr_type_consultation: "",
            consultation_group_sections: [],

            fiche_toggler: 0,
            fiche_id: 0,
            selected_fiche: '',
            info_consultation: {},
            fiche_sections: [],
            info_assurance_patient: {}
        }
    },

    watch: {
        panneauActionsDisponible: {
            immediate: true,
            handler(disponible) { this.$emit('actions-disponibles', disponible) }
        }
    },

    computed: {
        mode_complement() {
            return this.activeRole === 'ROLE_MEDECIN' && Number(this.consultationEnCours.is_end) === 1 &&
                !!this.consultationEnCours.complement
        },
        actions_cliniques_autorisees() { return ['ROLE_MEDECIN', 'ROLE_SAGE_FEMME'].includes(this.activeRole) },
        api_actions_consultation() { return this.activeRole === 'ROLE_SAGE_FEMME' ? sageFemmeApi : null },
        demarrage_depuis_tableau() {
            return ['ROLE_MEDECIN', 'ROLE_SAGE_FEMME'].includes(this.activeRole)
        },
        panneauActionsDisponible() {
            return Number(this.consultationEnCours.is_start) === 1 &&
                !this.group_section_loading && !this.group_section_error && !this.soins_avant_demarrage
        },
        ficheKineNative() {
            return this.consultation_group_sections.some(g => (g.sections || []).some(s => s.slug === 'kine_prescription'))
        },
        fiche_standard() {
            return ['Fiche patient', 'Fiche consultation modèle standard'].includes(this.selected_fiche)
        },
        groupe_actions() {
            if (this.mode_complement) return null
            return this.consultation_group_sections.find(group =>
                Number(group.groupe_id) === Number(this.current_consultation_evolution)) || null
        },
        soins_avant_demarrage() {
            return this.activeRole === 'ROLE_INFIRMIER' && Number(this.consultationEnCours.is_start) === 0 && Number(this.consultationEnCours.is_end) === 0
        },
        consultation_constantes() {
            return { consultation_id: this.consultationEnCours.id, patient_nom: [this.patient.nom, this.patient.prenoms].filter(Boolean).join(' '), dossier: this.patient.code, age: this.patient.age, sexe: this.patient.sexe, type_consultation: this.curr_type_consultation }
        },
        active_group_sections() {
            return this.$store.getters["active_group_sections"];
        },

        demande_analyses() {
            return this.$store.getters["demandeAnalyses"];
        },

        liste_prescription() {
            return this.$store.getters["consultationOrdonnance"];
        },

        // consultation_id_to_pass() {
        //     return this.consultation_id;
        // },

        consultationEnCours() {
            return this.$store.getters['consultationPatientEnCours'] || {}
        },

        // exam_physique_to_pass: {
        //     get() {
        //         return this.exam_physique;
        //     },
        //     set(value) {
        //         this.exam_physique = value
        //     }
        // },

        // facteursPonderations() {
        //     return this.$store.getters["facteursPonderations"];
        // },

        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        },

        current_consultation_evolution() {
            return this.$store.getters['current_consultation_evolution']
        },

        selected_consultation_encours() {
            return this.$store.getters['selected_consultation_encours']
        }
    },
    mounted() {
        this.getConsultationEnCoursByTypeConsultation()

        this.getPatientInfoAssurance()

        const ts = this;
        $(document).bind("click", function (e) {
            const $clicked = $(e.target);
            if (!$clicked.parents().hasClass("drp-container")) {
                if (ts.vm_state != 0) {
                    ts.openMenu(ts.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
                }
            }
        });
    },

    methods: {
        ordonnerSections(sections) {
            return sections.filter(section => section.slug === 'constante')
                .concat(sections.filter(section => section.slug !== 'constante'))
        },
        sectionCle(groupeId, section, index) {
            return `${groupeId}:${section.id || section.slug || 'section'}:${index}`
        },
        libelleSection(section) {
            return section.libelle
        },
        sectionEstRepliee(groupeId, section, index) {
            const key = this.sectionCle(groupeId, section, index)
            return this.sections_repliees[key] === undefined ? !!section.legacy_kine : Boolean(this.sections_repliees[key])
        },
        sectionEstChargee(groupeId, section, index) {
            return index < 3 || Boolean(this.sections_chargees[this.sectionCle(groupeId, section, index)])
        },
        toggleSection(groupeId, section, index) {
            const cle = this.sectionCle(groupeId, section, index)
            const repliee = this.sectionEstRepliee(groupeId, section, index)
            if (repliee) this.$set(this.sections_chargees, cle, true)
            this.$set(this.sections_repliees, cle, !repliee)
        },
        estEvaluationInitiale(group) {
            return Number(group.groupe_id) === Number(this.initiale_id || this.evolution_id_initiale)
        },
        titreGroupe(group) {
            if (this.mode_seance) return 'Séance'
            return this.estEvaluationInitiale(group) ? 'Évaluation initiale' : group.groupe
        },
        // refreshConsultation() {
        //     this.getConsultationEnCoursByTypeConsultation()
        // },

        getConsultationEnCoursByTypeConsultation(force = false) {
            this.group_section_loading = true
            this.group_section_error = false
            const param = {...this.selected_consultation_encours, user_id: this.user_id}

            // Le dossier vient de charger et de vérifier cette consultation. Réutiliser ce
            // résultat au montage évite un second aller-retour avant les sections.
            const deja_chargee = this.consultationEnCours
            const meme_consultation = force !== true && deja_chargee && deja_chargee.id &&
                Number(deja_chargee.id) === Number(param.consultation_id) &&
                Number(deja_chargee.patient_id) === Number(param.patient_id)
            // The parent dossier already authenticated and loaded the exact encounter,
            // including for nurses. Do not repeat the capability request and clinical read.
            const lecture = meme_consultation ? Promise.resolve(deja_chargee)
                : this.activeRole === 'ROLE_INFIRMIER'
                    ? this.lire_consultation_infirmier(param)
                    : param.source_tableau_sage_femme ? this.lire_consultation_sage_femme(param)
                    : this.$store.dispatch('getConsultationPatientEnCours', param)
            return lecture.then((consultation) => {
                if (!consultation || !consultation.id || (param.consultation_id && Number(consultation.id) !== Number(param.consultation_id))) {
                    throw new Error('Consultation indisponible')
                }
                if (Number(this.consultation_id) !== Number(consultation.id)) {
                    this.groupe_actif_id = null
                    this.groupes_ouverts = {}
                    this.groupes_charges = {}
                    this.groupe_togglers = {}
                    this.sections_repliees = {}
                    this.sections_chargees = {}
                    this.initiale_ouverte_consultation_id = null
                }
                this.consultation_id = consultation.id
                const tarif = this.consultationEnCours.tarif_consultation || {}
                this.curr_type_consultation = (tarif.type_consultation || {}).nom || ''
                this.fiche_id = this.consultationEnCours.fiche_consultation_id

                if (this.soins_avant_demarrage) {
                    return this.$store.dispatch('getEvolutionIDInitiale').then(() => {
                        const initiale = Number(this.evolution_id_initiale)
                        if (!Number.isInteger(initiale) || initiale <= 0) throw new Error('Consultation initiale indisponible')
                        this.initiale_id = initiale
                        this.groupe_actif_id = initiale
                        this.$store.commit('SET_CURRENT_CONSULTATION_EVOLUTION', initiale)
                        this.section_is_loading = false
                    })
                }

                return this.refreshListeFicheConsultationSection()
            }).catch(() => {
                this.signaler_erreur_chargement()
            }).finally(() => {
                this.group_section_loading = false
                return this.ouvrir_consultation_initiale()
            })
        },

        async lire_consultation_sage_femme(param) {
            if (this.activeRole !== 'ROLE_SAGE_FEMME') throw new Error('Rôle sage-femme requis')
            const credential = await sageFemmeApi.getTableauMedecinAccess()
            if (!credential.success || !credential.data || !credential.data.access_token) throw new Error('Accès indisponible')
            const consultation = await sageFemmeApi.ouvrirConsultationTableauMedecin({
                consultation_id: param.consultation_id, patient_id: param.patient_id,
                tarif_consultation_id: param.tarif_consultation_id, access_token: credential.data.access_token
            })
            if (this._isDestroyed || this.activeRole !== 'ROLE_SAGE_FEMME' ||
                Number(this.selected_consultation_encours.consultation_id) !== Number(param.consultation_id)) throw new Error('Contexte modifié')
            if (!consultation || Number(consultation.id) !== Number(param.consultation_id) || Number(consultation.is_end) === 1) throw new Error('Consultation indisponible')
            this.$store.commit('SET_PATIENT_LATEST_CONSULTATION', consultation)
            return consultation
        },

        async lire_consultation_infirmier(param) {
            const credential = await infirmier_api.getTableauInfirmierAccess()
            if (!credential.success || !credential.data || !credential.data.access_token) throw new Error('Accès indisponible')
            const consultation = await infirmier_api.ouvrirConsultation({ consultation_id: param.consultation_id, patient_id: param.patient_id, tarif_consultation_id: param.tarif_consultation_id, access_token: credential.data.access_token })
            if (!consultation || Number(consultation.id) !== Number(param.consultation_id) || Number(consultation.is_end) === 1) throw new Error('Consultation indisponible')
            this.$store.commit('SET_PATIENT_LATEST_CONSULTATION', consultation)
            return consultation
        },

        signaler_erreur_chargement() {
            this.group_section_error = true
            this.group_section_loading = false
            this.section_is_loading = false
        },

        getCurrentEvolution() {
            return this.$store.dispatch('getCurrentConsultationEvolution', this.consultation_id).catch(() => {
                this.signaler_erreur_chargement()
            })
        },

        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        refreshActiveSection() {
            return this.$store.dispatch('getEvolutionIDInitiale').then(() => {
                const initiale = Number(this.evolution_id_initiale)
                if (!Number.isInteger(initiale) || initiale <= 0) {
                    throw new Error('Consultation initiale indisponible')
                }
                if (!this.groupe_actif_id) this.groupe_actif_id = initiale
                this.initiale_id = initiale
                // List of default active group_section
                let data = {
                    consultation_id: this.consultation_id,
                    groupe_id: this.groupe_actif_id
                }
                this.info_consultation.consultation_id = this.consultation_id
                this.info_consultation.evolution_id = this.evolution_id_initiale
                return this.refreshListOfActiveGroupSection(data)
            }).catch(() => {
                this.signaler_erreur_chargement()
            })
        },

        refreshSection(group_id) {
            this.evolution_toggler = (this.evolution_toggler === 0) ? 1 : 0
            this.$set(this.groupe_togglers, group_id, this.groupe_togglers[group_id] === 1 ? 2 : 1)
            if (Number(this.groupe_actif_id) !== Number(group_id)) {
                this.groupe_actif_id = Number(group_id)
                const data = {
                    consultation_id: this.consultation_id,
                    groupe_id: group_id
                }
                return this.refreshListOfActiveGroupSection(data)
            }
        },

        async toggleGroupe(group) {
            const ouvert = !this.groupes_ouverts[group.groupe_id]
            this.groupes_ouverts = { [group.groupe_id]: ouvert }
            if (ouvert) {
                if (this.groupes_charges[group.groupe_id]) {
                    // Preserve already loaded section components and their data.
                    // Each section still has its own explicit refresh control.
                    if (Number(this.groupe_actif_id) !== Number(group.groupe_id)) {
                        this.groupe_actif_id = Number(group.groupe_id)
                        return this.refreshListOfActiveGroupSection({
                            consultation_id: this.consultation_id,
                            groupe_id: group.groupe_id
                        })
                    }
                    return
                }
                this.$set(this.groupes_charges, group.groupe_id, true)
                await this.$nextTick()
                if (this._isDestroyed) return
                return this.refreshSection(group.groupe_id)
            }
        },

        async ouvrir_consultation_initiale() {
            const consultation_id = Number(this.consultation_id)
            const query = this.$route && this.$route.query ? this.$route.query : {}
            // Seule la navigation qui vient de démarrer cette consultation demande
            // l'ouverture/positionnement automatique de l'évaluation initiale.
            if (query.initiale !== '1' || Number(query.med004) !== consultation_id) return
            if (this.initiale_ouverte_consultation_id === consultation_id ||
                this.group_section_loading || this.group_section_error ||
                Number(this.consultationEnCours.is_start) !== 1 || Number(this.consultationEnCours.is_end) === 1) return

            const initiale = Number(this.initiale_id || this.evolution_id_initiale)
            const group = this.consultation_group_sections.find(item => Number(item.groupe_id) === initiale)
            if (!initiale || !group || !Array.isArray(group.sections) || group.sections.length === 0) {
                this.signaler_erreur_chargement()
                return
            }

            // Ouverture explicite : ni clic simulé ni toggle susceptible de refermer H0.
            this.$set(this.groupes_ouverts, initiale, true)
            this.$set(this.groupes_charges, initiale, true)
            await this.$nextTick()
            if (this._isDestroyed || Number(this.consultation_id) !== consultation_id) return
            this.refreshSection(initiale)
            const refs = this.$refs['groupe_' + initiale]
            const element = Array.isArray(refs) ? refs[0] : refs
            if (!element) return
            this.initiale_ouverte_consultation_id = consultation_id
            this.positionner_groupe_initial(element)
        },

        positionner_groupe_initial(element) {
            const conteneur = element.closest && element.closest('.content-body')
            const fenetre = element.ownerDocument && element.ownerDocument.defaultView
            if (!conteneur || !fenetre) return
            let limite_haute = conteneur.getBoundingClientRect().top
            const dossier = element.closest('.patient-info')
            const bandeau = dossier && dossier.querySelector('.patient-sticky-shell')
            if (bandeau) {
                limite_haute = Math.max(limite_haute, bandeau.getBoundingClientRect().bottom)
            }
            const position = conteneur.scrollTop + element.getBoundingClientRect().top - limite_haute - 12
            const comportement = conteneur.style.scrollBehavior
            // Le conteneur .smooth ne doit pas animer cette unique arrivée dans le dossier.
            conteneur.style.scrollBehavior = 'auto'
            conteneur.scrollTop = Math.max(0, position)
            conteneur.style.scrollBehavior = comportement
        },

        addEvolution(evolution) {
            if (evolution == 0) {
                this.selected_evolution = {
                    groupe_id: 0
                }
            } else {
                this.selected_evolution = evolution
            }
        },

        refreshListConsultationGroupSection() {
            this.group_section_loading = true
            this.group_section_error = false
            this.groupes_ouverts = {}
            this.groupes_charges = {}
            this.groupe_togglers = {}

            return Promise.all([
                this.$store.dispatch('getListeConsultationGroupSection', this.consultation_id),
                this.refreshActiveSection(),
                this.getCurrentEvolution()
            ]).catch(() => {
                this.signaler_erreur_chargement()
            }).finally(() => {
                this.group_section_loading = false
            })
        },

        refreshListeFicheConsultationSection() {
            this.group_section_loading = true
            this.group_section_error = false

            const tarif = this.consultationEnCours.tarif_consultation || {}
            const data = {
                fiche_id: this.fiche_id,
                user_id: this.user_id,
                consultation_id: this.consultationEnCours.id,
                type_consultation_id: (tarif.type_consultation || {}).id
            }
            return Promise.all([store_fiche.getListeFicheConsultationSection(data).then((response) => {
                this.info_consultation.fiche_id = response.fiche_id
                
                this.selected_fiche = response.fiche === 'Fiche patient'
                    ? 'Fiche consultation modèle standard' : response.fiche
                const groupes = Array.isArray(response.groupe_section) ? response.groupe_section : []
                this.consultation_group_sections = groupes.map(group => ({
                    ...group,
                    sections: this.ordonnerSections(group.sections || [])
                        .filter(sectionDisponibleDansDossier)
                        .filter(section => !sectionsLegacyMasquees.has(section.slug))
                        .map(section => this.fiche_standard && section.slug === 'anamnese'
                            ? { ...section, libelle: 'Histoire de la maladie' } : section)
                }))
            }), this.refreshActiveSection(), this.getCurrentEvolution()]).then(() => {
                const initiale = this.consultation_group_sections.find(group => Number(group.groupe_id) === Number(this.initiale_id || this.evolution_id_initiale))
                this.fiche_sections = initiale && Array.isArray(initiale.sections) ? initiale.sections : []
                if (this.mode_seance) this.ouvrir_groupe_seance()
            }).catch(() => {
                this.signaler_erreur_chargement()
            }).finally(() => {
                this.group_section_loading = false
            })
        },

        refreshFicheConsultation(data) {
            this.fiche_id = data.fiche_id
            this.groupes_ouverts = {}
            this.groupes_charges = {}
            this.groupe_togglers = {}
            this.refreshListeFicheConsultationSection()
        },

        refreshListOfActiveGroupSection(data) {
            this.section_is_loading = true

            return this.$store.dispatch('getListeOfActiveGroupSections', data).then(() => {
                if (this.active_group_sections.length == 0) {
                    this.section_is_empty = true
                } else {
                    this.section_is_empty = false
                }
            }).catch(() => {
                this.signaler_erreur_chargement()
            }).finally(() => {
                this.section_is_loading = false
            })
        },

        /**
         * Dis si la sage femme peut voir le score issu des facteurs de ponderation
         * @returns 
         */
        canSeeScore() {
            let err = false
            for (let i = 0; i < this.facteursPonderations.length; i++) {
                if (this.facteursPonderations[i].selected != null) {
                    err = true
                }
            }

            return err
        },

        addAnalyse() {

            this.analyse = true

            $('#stick-anchor').animate({
                scrollTop: $('#analyse').offset().top
            }, 800, function () { });
        },

        /**
         * Affiche la section CONDITION A TENIR
         */
        showCAT() {
            $('#stick-anchor').animate({
                scrollTop: $('#cat').offset().top
            }, 800, function () { });

            this.conduite = true;
        },

        /*
         *
         *Affiche la section ordonnance
         * 
         * */
        showOrdonnance() {
            this.ordonnance = true;

            $('#stick-anchor').animate({
                scrollTop: $('#ordonnance').offset().top
            }, 800, function () { });

        },

        endConsultation() {
            if (!this.actions_cliniques_autorisees || !this.$refs.cloture_consultation) return
            if (Number((this.consultationEnCours || {}).is_end) === 1) return
            if (this.kine_loading || this.kine_error || (this.kine_candidates && this.kine_candidates.length)) return
            this.$refs.cloture_consultation.open()
        },
        ouvrirAvisMedical() {
            if (!this.actions_cliniques_autorisees || !this.$refs.avis_medical) return
            this.$refs.avis_medical.ouvrir()
        },

        // RDV-006 : fenêtre « Donner un rendez-vous » (médecin), depuis les actions de la consultation
        ouvrir_rendez_vous() {
            if (!this.actions_cliniques_autorisees || !this.$refs.donner_rendez_vous) return
            this.$refs.donner_rendez_vous.ouvrir()
        },
        rendez_vous_enregistre() {
            const cloture = this.$refs.cloture_consultation
            if (cloture && cloture.visible && cloture.sameContext()) cloture.prochaine_enregistree = true
        },

        reorder(evolution) {
            this.selected_evolution = evolution
        },

        /**
         * Visualiser résultat analyse bio
         * @param {*} param 
         */
        setOnGoingAnalyseResult(param) {
            this.toggler = (this.toggler == 0)?1:0
            this.demande_analyse = param.demande_analyse
            this.evolution_id = param.evolution_id
            setTimeout(() => {
                $('#modalResultat'+param.evolution_id).modal('show');
            }, 500);
        },

        /**
         * Visualiser résultat examen paraclinique
         * @param {*} param 
         */
        setOnGoingExamenParaResult(param) {
            this.result_toggler = (this.result_toggler == 0)?1:0
            this.demande_examen = param.result_preview
            this.info_resultat = param.info_resultat
            this.evolution_id = param.evolution_id
            setTimeout(() => {
                $('#view-result-examen'+param.evolution_id+param.info_resultat.demande_id).modal('show');
            }, 500);
        },

        browseFiche() {
            this.fiche_toggler = (this.fiche_toggler == 0)?1:0
            $('.browse-fiche').modal('show')
        },

        startConsultation() {
            if (this.activeRole === 'ROLE_INFIRMIER' || this.demarrage_depuis_tableau) return
            this.$refs.choix_fiche.ouvrir_demarrage()
        },

        getPatientInfoAssurance() {
            store_patient.getInfoAssurancePatient(this.patient.id).then((response) => {
                this.info_assurance_patient = response
            })
        }
    }
}
